import { t } from '../../i18n-t';
import type { FormConfig } from '../types';

export const getObligationImpactFormConfig = () => {
  return {
    Description: {
      fieldId: 'Description',
      formLabel: t('impacts.fields.Description'),
    },
    ImpactRating: {
      fieldId: 'ImpactRating',
      formLabel: t('impacts.fields.ImpactRating'),
      displayType: {
        displayType: 'rating',
        ratingKey: 'impact',
      },
      allowAsConditionSource: true,
    },
  } as const satisfies FormConfig;
};
